<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header">

                        <div class="card-body table-responsive">
                            <div class="row mb-2 align-items-end">
                                <div class="col-xl-2 col-md-3 col-sm-6 col-12 mb-2">
                                    <label>{{$t("report.date.startDate")}}</label>
                                    <!--<custom-date-picker-->
                                            <!--class="form-control"-->
                                            <!--:disabledDates="{to: new Date('10/01/2020')}"-->
                                            <!--v-model="filter.startDate"-->
                                            <!--:date="filter.startDate"-->
                                            <!--:clear-button="true">-->
                                    <!--</custom-date-picker>-->

                                    <datepicker
                                            class="form-control"
                                            format="dd/MM/yyyy"
                                            v-model="filter.startDate"
                                            :clear-button="true"
                                            @input="changeStartDate"
                                    ></datepicker>
                                </div>
                                <div class="col-xl-2 col-md-3 col-sm-6 col-12 mb-2">
                                    <label>{{$t("report.date.endDate")}}</label>
                                    <datepicker
                                            class="form-control"
                                            format="dd/MM/yyyy"
                                            v-model="filter.endDate"
                                            :clear-button="true"
                                    ></datepicker>
                                </div>
                                <div v-if="isAuthorized" class="col-xl-3 col-lg-4 col-md-6 col-sm-12 col-12 mb-2" style="padding-right: 2rem;">
                                    <label>{{$t("report.field.agents")}}</label>
                                    <AgentSelect v-model="filter.user" :data="filter.user">
                                    </AgentSelect>
                                </div>

                                <!--<div class="col-sm-1">-->
                                <!--<label style="align-self: center">{{$t("main.search")}}</label>-->
                                <!--<button class="all-btn form-control" @click="initList"-->
                                <!--style="color: #fff;background-color: #00bcd4;border-color: #00bcd4;-->
                                <!--box-shadow: 0 2px 2px 0 rgba(0, 188, 212, .14),-->
                                <!--0 3px 1px -2px rgba(0, 188, 212, .2),-->
                                <!--0 1px 5px 0 rgba(0, 188, 212, .12)">-->
                                <!--<i class="fa fa-filter"></i>-->
                                <!--</button>-->
                                <!--</div>-->
                                <div class="col-xl-3 col-lg-4 col-md-5 col-sm-8 col-12 mb-2">
                                    <label for="search">{{$t('finance.field.search')}}</label>
                                    <div class="input-group">
                                        <input class="form-control search-input" type="text" :placeholder="$t('main.search')"
                                               id="search"
                                               v-model.trim="filter.search" @keypress.enter="initList">
                                        <div class="input-group-append">
                                            <button class="all-btn search-btn" @click="initList">
                                                <i class="fa fa-search"></i>
                                                <span>{{$t('finance.field.search')}}</span>
                                            </button>
                                        </div>
                                    </div>
                                </div>

                                <div v-if="hasPermission('CASH_TRANSFER') && isAppraiserHelper" class="col-md-2 col-sm-4 col-12">
                                    <button type="button" class="all-btn delete-btn ml-0 ml-sm-auto ml-md-0 ml-xl-auto mb-2" @click="addAppraiserHelperUrl()">
                                        {{$t("finance.deposit.cashTransfer")}}
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="table-wrapper">
                              <table class="customers">
                                  <thead class="table-head">
                                  <tr>
                                      <th rowspan="3" width="35%">Агент Ф.И.О</th>
                                      <th rowspan="3" width="5%">Объект номи</th>
                                      <th colspan="4">Кирим</th>
                                      <th colspan="4">Чиким</th>
                                  </tr>
                                  <tr>
                                      <th colspan="2">Бажарилган иш</th>
                                      <th colspan="2">Депозит тўлдириш</th>
                                      <th colspan="2">Бажарилган иш</th>
                                      <th colspan="2">Депозитдан чиким</th>
                                  </tr>
                                  <tr>
                                      <th>Сана</th>
                                      <th>Сумма</th>
                                      <th>Сана</th>
                                      <th>Сумма</th>
                                      <th>Сана</th>
                                      <th>Сумма</th>
                                      <th>Сана</th>
                                      <th>Сумма</th>
                                  </tr>
                                  </thead>
                                  <tbody v-if="!loading && results && results.data">
                                  <tr v-for="(result) in results.data" :key="result.index">
                                      <td :title="result.evaluationObjectFullInfo" class="font-weight-bold">
                                          <span class="font-weight-bold">#{{result.objectId}}</span>
                                          <span class="">
                                              {{result.objectName}}
                                          </span><br/>
                                          <span class="font-weight-bold small">
                                              <b>{{result.createUserName}}</b>
                                          </span>
                                      </td>
                                      <td class="text-center">
                                          <span>
                                          {{result.evlObjectType}}
                                          </span>
                                      </td>
                                      <td class="text-center">
                                          <span v-if="result.confirmedDate">
                                          {{result.confirmedDate}}
                                          </span>
                                      </td>
                                      <td class="text-center">
                                          <span :style="statusColor(result.agentDepositId)"
                                          v-if="result.agentSalary" >
                                              {{result.agentSalary | currency('', 2, { thousandsSeparator: ' ' })}}
                                          </span>
                                      </td>
                                      <td class="text-right">
                                          <template v-if="result.payAmount">
                                              <span class="font-weight-bold dz-size"> {{result.payAmount | currency('', 2, { thousandsSeparator: ' ' })}}</span>
                                          </template>
                                      </td>
                                      <td>{{result.creditName}}</td>
                                      <td>{{result.paymentDate}}</td>
                                      <td>{{result.agentTransactionAmount | currency('', 2, { thousandsSeparator: ' ' })}}</td>
                                      <td>{{result.creditAccount}}</td>
                                      <td>{{result.creditAccount}}</td>
                                      <!--<td style="word-break: break-all">{{result.creditPurpose}}</td>-->
                                  </tr>
                                  </tbody>
                                  <tfoot>
                                  <tr>
                                      <td class="font-weight-bold"><span></span></td>
                                      <td class="text-right font-weight-bold"></td>
                                      <td class="text-right font-weight-bold"></td>
                                      <td class="text-right font-weight-bold">{{ totalAgentSalary.balance | currency('', 2, { thousandsSeparator: ' ' }) }}</td>
                                      <td class="text-right font-weight-bold"></td>
                                      <td class="text-right font-weight-bold"></td>
                                      <td class="text-right font-weight-bold"></td>
                                      <td class="text-right font-weight-bold">{{ totalAgentSalary.paymentAmount | currency('', 2, { thousandsSeparator: ' ' }) }}</td>
                                      <td colspan="0" class="font-weight-bold"></td>
                                      <td colspan="0" class="font-weight-bold"></td>
                                  </tr>
                                  <tr>
                                      <td class="font-weight-bold">Баланс:</td>
                                      <td colspan="9" class="font-weight-bold text-center"><span style="font-size: 20px;">{{totalAgentSalary.balance | currency('', 2, { thousandsSeparator: ' ' }) }}</span></td>
                                  </tr>
                                  <tr>
                                      <td class="font-weight-bold">Фойдаланувчи баланси қолдиғи:</td>
                                      <td colspan="9" class="font-weight-bold text-center"><span style="font-size: 20px;">{{totalAgentSalary.totalUserBalance | currency('', 2, { thousandsSeparator: ' ' }) }}</span></td>
                                  </tr>
                                  </tfoot>
                              </table>
                            </div>
                        </div>
                        <div class="text-center">
                            <div class="loader mt-5 mb-5" v-if="loading"></div>
                            <span class="no-data mt-5 mb-5"
                                  v-if="!loading && results && results.data && results.data.length===0">{{$t("messages.list.empty")}}</span>
                        </div>
                        <div class="row" v-if="!loading && results && results.total && results.total > 1">
                            <div class="col-12 pt-3 pb-3">
                                <b-pagination :total-rows="results.total" v-model="filter.page.page"
                                              :per-page="filter.page.size" @change="onPageChange">
                                </b-pagination>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import initFilterModel from '@/shared/filter'
    import bPagination from 'bootstrap-vue/es/components/pagination/pagination';
    import Datepicker from 'vuejs-datepicker';
    import AgentSelect from '@/components/AgentSelect';
    // import CustomDatePicker from '@/views/common/CustomDatePicker'

    import {formatDate/*, parseDate, formatDateText, findBy*/} from '@/shared/utils';

    export default {
        name: "DepositList",
        components: {
            'b-pagination': bPagination,
            Datepicker,
            AgentSelect,
            // CustomDatePicker
        },
        data() {
            return {
                loading: false,
                filter: initFilterModel(),
                results: null,
                data: null,
                fromBalanceDate: new Date("01/06/2022"),
                newfromBalanceDate: null,
                isAuthorized: false,
                isAppraiserHelper: false,
                depositsDto: {
                    id: null,
                    userCardsType: null
                }
            }
        },
        methods: {
            initList() {
                this.loading = true;
                this.isAuthoritie();
                this.isRoleAppraiserHelper();
                this.$http.post('/report/list/deposit', this.filter)
                    .then(res => {
                        this.results = res;
                        this.newfromBalanceDate = this.filter.startDate;
                        this.loading = false
                    }, err => {
                        console.log(err);
                        this.loading = false
                    });
            },
            onPageChange(page) {
                this.filter.page.page = page;
                this.initList();
            },
            changeStartDate(/*$event*/) {
                if (this.filter.startDate < this.fromBalanceDate) {
                    this.filter.startDate = this.fromBalanceDate;
                    this.newfromBalanceDate = this.filter.startDate;
                    this.$swal({
                        title: this.$t('messages.common.warning'),
                        text: formatDate(this.fromBalanceDate) + ' дан олдинги сана танлаш мумкин эмас',
                        type: 'warning'
                    });
                }
            },

            addAppraiserUrl() {
                const totalCash = (this.totalAgentSalary.totalUserBalance);
                if (totalCash <= 0) {
                    this.$swal({
                        title: this.$t('common.error'),
                        text: " Summa 0 dan ko'p bo'lishi kerak ",
                        type: 'error'
                    });
                    return;
                }
                this.depositsDto.user = this.$store.state.profile;
                this.depositsDto.cash = totalCash;
                this.depositsDto.userCardsType = 'DEPOSIT';
                this.loading = true;
                this.$http.post('deposits/user/save', this.depositsDto)
                    .then(res => {
                        const response = res.data;
                        if (response.status === 'SUCCESS') {
                            this.$router.push("users-balance-list");
                        } else {
                            this.$swal({
                                title: this.$t('common.warning'),
                                text: response.message,
                                type: 'warning'
                            });
                        }
                        this.loading = false;
                    }, err => {
                        this.loading = false;
                        console.log(err);
                    });
            },

            isAuthoritie() {
                const authorities = this.$store.state.profile.authorities;
                for (const role of authorities) {
                    if (role == "ROLE_GENERAL_DIRECTOR" || role == "ROLE_DIRECTOR") {
                        this.isAuthorized = true;
                    }

                }
            },
            isRoleAppraiserHelper() {
                const authorities = this.$store.state.profile.authorities;
                for (const role of authorities) {
                    if (role == "ROLE_APPRAISER_HELPER") {
                        this.isAppraiserHelper=true;
                    }
                }
            },
            statusColor(rights) {
                if (rights == null) {
                    return 'color:blue;font-weight:bold';
                } else {
                    return 'color:red;font-weight:bold';
                }
            }

        },
        created() {

            // var d = new Date();
            // var currMonth = d.getMonth();
            // var currYear = d.getFullYear();
            // this.filter.startDate = new Date(currYear, currMonth - 1, 1);
            // this.filter.endDate = new Date(currYear, currMonth, 1);

            this.filter.startDate = new Date(this.fromBalanceDate.getFullYear(), this.fromBalanceDate.getMonth(), 1);
            this.filter.endDate = new Date();


            this.initList()
        },
        computed: {
            totalAgentSalary() {
                let result = 0;
                let paymentAmount = 0;
                let totalUserBalance = 0;
                if (this.results!=null) {
                    Object.keys(this.results.data).forEach(key => {
                        let val = this.results.data[key];
                        result = result + parseFloat(val.agentSalary);
                        paymentAmount = paymentAmount + parseFloat(val.agentTransactionAmount);
                        if (val.agentDepositId === undefined) {
                            totalUserBalance = totalUserBalance + parseFloat(val.agentSalary);
                        }
                    });
                }
                return {"balance": result, "paymentAmount": paymentAmount, "totalUserBalance": totalUserBalance};

            }
        }
    }
</script>

<style scoped>

</style>